/**
* @internal
*/
function _isEnterToClickElement(element) {
	return isHTMLAnchorElement(element) || isHTMLButtonElement(element);
}
/**
* @internal
*/
function isHTMLElement(node) {
	return node instanceof Node && node.nodeType === Node.ELEMENT_NODE;
}
/**
* @internal
*/
function isHTMLAnchorElement(element) {
	return isHTMLElement(element) && element.nodeName === "A";
}
/**
* @internal
*/
function isHTMLInputElement(element) {
	return isHTMLElement(element) && element.nodeName === "INPUT";
}
/**
* @internal
*/
function isHTMLButtonElement(element) {
	return isHTMLElement(element) && element.nodeName === "BUTTON";
}
/**
* @internal
*/
function isHTMLSelectElement(element) {
	return isHTMLElement(element) && element.nodeName === "SELECT";
}
/**
* @internal
*/
function isHTMLTextAreaElement(element) {
	return isHTMLElement(element) && element.nodeName === "TEXTAREA";
}
/**
* @internal
*/
function containsOrEqualsElement(element, node) {
	return element.contains(node) || element === node;
}
export { isHTMLElement as a, isHTMLTextAreaElement as c, isHTMLButtonElement as i, containsOrEqualsElement as n, isHTMLInputElement as o, isHTMLAnchorElement as r, isHTMLSelectElement as s, _isEnterToClickElement as t };

//# sourceMappingURL=element-BYgCE_iK.js.map